import { ImageFragment, LinkFragment } from '@/lib/fragments'

import { graphql } from '@/lib/query'

const SectionListFragment = graphql(
  /* GraphQL */ `
    fragment SectionListFragment on SectionListRecord @_unmask {
      id
      _modelApiKey
      __typename
      title
      text
      items {
        title
        text
      }
    }
  `,
  [ImageFragment, LinkFragment]
)

export default SectionListFragment
